import React, { useEffect, useRef, useState } from 'react';
import { render } from 'react-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { isMobile } from '@zola-helpers/client/dist/es/util/responsive';
import { getCookie } from '@zola-helpers/client/dist/es/util/storage';

const useRecaptchaV2 = ({
  recaptchaContainer,
  ready = true,
}: {
  recaptchaContainer: HTMLElement | null;
  ready?: boolean;
}): ReCAPTCHA | null => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const recaptchaContainerRef = useRef(document.createElement('div'));
  const isAutomatedTest = getCookie('automatedTest') === 'true';
  const [hasMounted, setHasMounted] = useState(false);

  if (!isAutomatedTest && ready && !hasMounted) {
    setHasMounted(true);
    render(
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey="6Lf91DcfAAAAACNVXd1VdLe-Ty6IWlGHvHZ7jRmk"
        size="invisible"
        badge={isMobile() ? 'inline' : undefined}
      />,
      recaptchaContainerRef.current
    );
  }

  useEffect(() => {
    const { current } = recaptchaContainerRef;
    if (recaptchaContainer) recaptchaContainer.appendChild(current);
    return () => {
      if (recaptchaContainer) recaptchaContainer.removeChild(current);
      setHasMounted(false);
    };
  }, [recaptchaContainer]);

  return recaptchaRef.current;
};

export default useRecaptchaV2;
